import { Component, computed, inject, signal } from "@angular/core";
import {
  Router,
  ResolveStart,
  ResolveEnd,
  NavigationEnd,
  Event,
  RouterOutlet,
} from "@angular/router";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from "../footer/footer.component";
import { CookiesBannerComponent } from "../../shared/component/cookies-banner/cookies-banner.component";
import { OnboardingSidebarComponent } from "../../routes/onboarding/components/onboarding-sidebar/onboarding-sidebar.component";
import { OnboardingService } from "../../routes/onboarding/onboarding.service";

@Component({
  selector: "app-onboarding-layout",
  templateUrl: "./onboarding-layout.component.html",
  styleUrls: ["./onboarding-layout.component.scss"],
  imports: [
    MatProgressSpinner,
    HeaderComponent,
    RouterOutlet,
    FooterComponent,
    CookiesBannerComponent,
    OnboardingSidebarComponent,
  ],
})
export class OnboardingLayoutComponent {
  private readonly service = inject(OnboardingService);
  private readonly router = inject(Router);

  private readonly _routerLoading = signal(true);
  protected readonly loading = computed(
    () => this._routerLoading() || this.service.loading(),
  );

  constructor() {
    this.router.events.subscribe((e: Event) => {
      switch (true) {
        case e instanceof ResolveStart: {
          this._routerLoading.set(true);
          break;
        }
        case e instanceof ResolveEnd:
        case e instanceof NavigationEnd: {
          this._routerLoading.set(false);
          break;
        }
      }
    });
  }
}
